export default "__VITE_PUBLIC_ASSET__fca54326__"